import { Controller } from 'stimulus';
import sanitizer from '../mixins/coupon_code_sanitizer';

export default class extends Controller {
  static targets = ['label', 'input', 'cta', 'apply', 'confirmation', 'error'];
  visibleClass = 'is-visible';
  successClass = 'is-valid';
  errorClass = 'is-invalid';

  async connect() {
    if (this.couponCodePresent()) {
      this.showCouponEntry();
      await this.applyCoupon();
    } else {
      this.hideCouponEntry();
    }
  }

  showCouponEntry() {
    this.element.classList.add(this.visibleClass);
  }

  hideCouponEntry() {
    this.element.classList.remove(this.visibleClass);
  }

  async applyCoupon() {
    const sanitizedInputValue = sanitizer(this.inputTarget.value);
    this.data.set('userCoupon', sanitizedInputValue);

    const subscriptionElement = document.querySelector(
      'div[data-controller="subscription-details"]'
    );
    const subscriptionController = this.application.getControllerForElementAndIdentifier(
      subscriptionElement,
      'subscription-details'
    );
    const couponApplied = await subscriptionController.applyCoupon();
    this.updateCouponInput(sanitizedInputValue);
    this.updateHiddenCouponInput(sanitizedInputValue, couponApplied);
    if (sanitizedInputValue === '') {
      this.removeStatusClasses();
    } else {
      this.toggleCouponStatus(couponApplied);
    }
  }

  couponCodePresent() {
    return this.inputTarget.value.length > 0;
  }

  toggleCouponStatus(applied) {
    if (applied) {
      this.element.classList.remove(this.errorClass);
      this.element.classList.add(this.successClass);
      this.inputTarget.classList.remove(this.errorClass);
    } else {
      this.element.classList.add(this.errorClass);
      this.element.classList.remove(this.successClass);
      this.inputTarget.classList.add(this.errorClass);
    }
  }

  removeStatusClasses() {
    this.element.classList.remove(this.errorClass, this.successClass);
  }

  updateCouponInput(value) {
    this.inputTarget.value = value;
  }

  updateHiddenCouponInput(value, applied) {
    const hiddenCouponInput = document.getElementById(
      'subscription_form_coupon_code'
    );
    hiddenCouponInput.value = applied ? value : '';
  }
}
